import { Pipe, PipeTransform } from '@angular/core';
import { AuthStore } from '../../core/auth/services/auth.store';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'secure',
  pure: true,
})
export class SecureRessourcePipe implements PipeTransform {
  constructor(
    private authStore: AuthStore,
    private domSanitizer: DomSanitizer // our service that provides us with the authorization token
  ) {}

  async transform(src: string): Promise<any> {
    try {
      return fetch(src, {
        headers: {
          Authorization: 'Bearer ' + this.authStore.state.token.accessToken,
        },
      })
        .then((res) => res.blob())
        .then((blob) => this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob)));
    } catch {
      return 'assets/fallback.png';
    }
  }
}
